export const LAG_CV_PERIODS = ["one-day", "one-week", "four-weeks"] as const;
export type LagCvPeriodType = typeof LAG_CV_PERIODS[number];